import {
  PhoneCategory,
  StorePhotoCategory,
} from '../../../generated/globalTypes';
import {
  phoneCategories,
  photoCategories,
} from '../constants/categoryUnverified';

export const generateDetailUnverified = (
  category: StorePhotoCategory | PhoneCategory | null,
) => {
  if (!category) {
    return '';
  }

  switch (category) {
    case StorePhotoCategory.STORE_PHOTO_FRONT:
      return photoCategories[0].value;
    case StorePhotoCategory.STORE_PHOTO_INSIDE:
      return photoCategories[1].value;
    case PhoneCategory.ANSWERED:
      return phoneCategories[0].value;
    case PhoneCategory.NOT_ANSWERED:
      return phoneCategories[1].value;
  }
};
